import React, {Component} from 'react';
import {connect} from "react-redux";
import * as AdminActions from '../../../store/actions/adminActions';
import {withRouter} from 'react-router-dom';
import userImage from "../../../assets/128x128.jpg";
import api from "../../../utils/api";

class Comments extends Component {

    componentDidMount() {
        this.props.getComments(0, this.props.match.params.courseId, this.props.user.id);
    }

    componentDidUpdate(props) {
        if (props.match.params.courseId !== this.props.match.params.courseId) {
            this.props.getComments(0, this.props.match.params.courseId, this.props.user.id);
        }
    }

    loadMore = () => {
        this.props.getComments(this.props.comments.length, this.props.match.params.courseId, this.props.user.id);
    }

    renderImg = (comment) => {

        if(comment.Profile){
            let avatar = userImage;
            if(comment.Profile.avatar){
                if(comment.Profile.avatar.indexOf('http') > -1){
                    avatar = comment.Profile.avatar;
                }else{
                    avatar = api.makeFileURL(comment.Profile.avatar, this.props.user.id);
                }
            }
            return (
                <img
                    src={avatar}
                    alt={comment.Profile.name}
                />
            )
        }else{
            return (
                <img
                    src={userImage}
                    alt={""}
                />
            )
        }
    }

    resolveComment = (e, resolved, comment) => {
        e.preventDefault();

        comment.resolved = resolved;
        this.props.updateComment(comment, this.props.user.id);

    }

    render () {
        return (
            <div className={"row"}>
                <div className={"col-sm-12"}>
                    <div className={"panel customPanel"}>
                        <div className={"panel-body no-padding"}>
                            {this.props.comments ?
                                this.props.comments.map(c => {
                                    return (
                                        <div className="db-comment text-white">
                                            <div className="sm-bottom30">
                                                <p className="font-300">{c.content}</p>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-3">
                                                    <div className="user-image-name-wrap">
                                                        {this.renderImg(c)}
                                                            <p>{c.Profile ? c.Profile.name + " " + c.Profile.lname : "99Point9 User"}</p>
                                                    </div>
                                                </div>
                                                <div className="col-sm-3">
                                                    <p>{c.Subject ? c.Subject.name : ''}</p>
                                                </div>
                                                <div className="col-sm-3">
                                                    <p>Lecture: {c.ChapterVideo ? c.ChapterVideo.title : 'Deleted Lecture'}</p>
                                                </div>
                                                <div className="col-sm-3 text-right">
                                                    {c.resolved ?
                                                        <a href="#c" className="text-success" onClick={e => this.resolveComment(e,false, c)}><i className={"zmdi zmdi-check"} /> Resolved</a>
                                                    : <a href="#c" onClick={e => this.resolveComment(e,true, c)}>Mark as addressed</a>
                                                    }

                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            : null}


                        </div>


                    </div>

                    {(this.props.commentCount > this.props.comments.length) && !this.props.loadingComments ?
                        <div className="text-center">
                            <button className="btn btn-danger" onClick={e => {
                                this.loadMore()
                            }}><i className="zmdi zmdi-refresh" /> &nbsp; Load More</button>
                        </div>

                        : null}
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    ...state.auth,
    ...state.adminInfo
});

const mapDispatchToProps = dispatch => ({
    getComments: (skip, courseId, token) => {
        dispatch(AdminActions.getComments(skip, courseId, token));
    },
    updateComment: (comment, token) => {
        dispatch(AdminActions.updateComment(comment, token));
    }
});

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(Comments));


// WEBPACK FOOTER //
// ./src/components/AdminConsole/Panels/Comments.js